import React from "react";
import { Box, Card, CardContent, Typography, Button } from "@mui/material";
import { styled, keyframes } from "@mui/system";
import {
  SiAwsamplify,
  SiSpring,
  SiReact,
  SiGit,
  SiBitbucket,
} from "react-icons/si";
import SettingsIcon from "@mui/icons-material/Settings";
import logoImage from "../../assets/images/loglobwk.jpeg";

// Animaciones
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const orbit = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

// Contenedor principal estilizado
const PortfolioContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: theme.spacing(4),
  flexWrap: "wrap",
  padding: theme.spacing(4),
  backgroundColor: theme.palette.background.default,
  minHeight: "100vh",
  animation: `${fadeIn} 1s ease-in-out`,
}));

// Card estilizado
const ProjectCard = styled(Card)(({ theme }) => ({
  width: "320px",
  height: "450px",
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.text.primary,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "space-between",
  padding: theme.spacing(3),
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[4],
  animation: `${fadeIn} 1.2s ease-in-out`,
}));

// Botón estilizado
const StyledButton = styled(Button)(({ theme }) => ({
  width: "90%",
  padding: theme.spacing(1.5),
  fontWeight: theme.typography.fontWeightBold,
  fontSize: theme.typography.button.fontSize,
  borderRadius: theme.shape.borderRadius,
  transition: "background-color 0.3s ease",
  alignSelf: "center",
  backgroundColor: theme.palette.primary.main, // Color principal (verde)
  color: theme.palette.primary.contrastText, // Texto contrastante
  "&:hover": {
    backgroundColor: theme.palette.primary.dark, // Color oscuro en hover
  },
}));

// Título estilizado
const Title = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontWeight: theme.typography.fontWeightBold,
  fontSize: theme.typography.h6.fontSize,
  textAlign: "center",
}));

// Icono animado
const GearIcon = styled(SettingsIcon)(({ theme }) => ({
  fontSize: theme.spacing(14),
  color: theme.palette.text.secondary,
  animation: `${orbit} 5s linear infinite`,
  marginTop: theme.spacing(3),
  marginBottom: theme.spacing(3),
}));

// Imagen de vista previa estilizada
const PreviewImage = styled("img")(({ theme }) => ({
  width: "100%",
  height: "180px",
  objectFit: "contain",
  borderRadius: theme.shape.borderRadius,
  marginBottom: theme.spacing(2),
  animation: `${fadeIn} 1.5s ease-in-out`,
}));

const PortfolioComponent = () => {
  return (
    <PortfolioContainer>
      {/* Proyecto POS en Spring Boot y AWS */}
      <ProjectCard>
        <CardContent style={{ textAlign: "center" }}>
          <Box display="flex" justifyContent="center" gap={1} mb={2}>
            <SiSpring size={32} color="#6DB33F" />
            <SiReact size={32} color="#61DAFB" />
            <SiAwsamplify size={32} color="#FF9900" />
            <SiGit size={32} color="#F05032" />
            <SiBitbucket size={32} color="#2684FF" />
          </Box>
          <Title variant="h6" gutterBottom>
            POS en Spring Boot y AWS
          </Title>
          <Typography variant="body2" sx={{ color: "text.primary", mb: 2 }}>
            En desarrollo
          </Typography>
          <Box display="flex" justifyContent="center" mb={2}>
            <GearIcon />
          </Box>
          <Typography
            variant="body2"
            sx={{ color: "text.secondary", fontWeight: "bold", textAlign: "center" }}
          >
            Acceso restringido: Solicite acceso mediante el formulario de contacto.
          </Typography>
        </CardContent>
      </ProjectCard>

      {/* Proyecto de página estática */}
      <ProjectCard>
        <CardContent style={{ textAlign: "center" }}>
          <PreviewImage src={logoImage} alt="Logo de ServiciosSM" />
          <Title variant="h6" gutterBottom>
            ServiciosSM
          </Title>
          <Typography
            variant="body2"
            sx={{ color: "text.primary", marginBottom: 2 }}
          >
            Un sitio web estático y responsive diseñado con React, mui y vite.
          </Typography>
          <StyledButton
            variant="contained"
            href="https://servicios-sm.vercel.app/"
            target="_blank"
          >
            Ver Proyecto
          </StyledButton>
        </CardContent>
      </ProjectCard>
    </PortfolioContainer>
  );
};

export default PortfolioComponent;
